import React from "react";
import { get } from "lodash";
import themePropTypes from "../theme-prop-types";

const Link = ({
  label,
  onClick,
  className,
  name,
  targetBlank,
  text = "",
  ariaLabel = "",
  accessibility = {},
  data
}) => {
  const accessibilityAttributes = {
    "aria-label": ariaLabel || accessibility.ariaLabel,
    tabIndex: accessibility.tabIndex,
    role: accessibility.role
  };

  const Tag = get(data, "tag");

  return Tag ? (
    <Tag data-testid={`link-${name}`} {...accessibilityAttributes}>
      {label}
    </Tag>
  ) : (
    <button
      data-testid={`link-${name}${
        text ? `-${text.replace(/(\r\n|\n|\r| )/gm, "")}` : ""
      }`}
      className={`linkComponent link-web-sdk ${
        targetBlank ? "external-link" : ""
      } ${className || ""}`}
      type='button'
      onClick={onClick}
      {...accessibilityAttributes}
    >
      {label}
    </button>
  );
};

Link.propTypes = themePropTypes.link;

export default Link;
